module.exports = __webpack_public_path__ + "static/media/first.ca19c96d.png";